/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Least_PrivilegeInputs */

const en_svchip_least_privilege = /** @type {(inputs: Svchip_Least_PrivilegeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Least privilege`)
};

const ar_svchip_least_privilege = /** @type {(inputs: Svchip_Least_PrivilegeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أقل صلاحيات`)
};

const bn_svchip_least_privilege = /** @type {(inputs: Svchip_Least_PrivilegeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ন্যূনতম অনুমতি`)
};

const de_svchip_least_privilege = /** @type {(inputs: Svchip_Least_PrivilegeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geringstes Privileg`)
};

const es_svchip_least_privilege = /** @type {(inputs: Svchip_Least_PrivilegeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privilegio mínimo`)
};

const fr_svchip_least_privilege = /** @type {(inputs: Svchip_Least_PrivilegeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moindre privilège`)
};

const pt_svchip_least_privilege = /** @type {(inputs: Svchip_Least_PrivilegeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privilégio mínimo`)
};

const zh_svchip_least_privilege = /** @type {(inputs: Svchip_Least_PrivilegeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最低权限`)
};

const tr_svchip_least_privilege = /** @type {(inputs: Svchip_Least_PrivilegeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En az ayrıcalık`)
};

const ru_svchip_least_privilege = /** @type {(inputs: Svchip_Least_PrivilegeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наименьшие привилегии`)
};

const pl_svchip_least_privilege = /** @type {(inputs: Svchip_Least_PrivilegeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najmniejsze uprawnienia`)
};

/**
* | output |
* | --- |
* | "Least privilege" |
*
* @param {Svchip_Least_PrivilegeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_least_privilege = /** @type {((inputs?: Svchip_Least_PrivilegeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Least_PrivilegeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_least_privilege(inputs)
	if (locale === "bn") return bn_svchip_least_privilege(inputs)
	if (locale === "de") return de_svchip_least_privilege(inputs)
	if (locale === "es") return es_svchip_least_privilege(inputs)
	if (locale === "fr") return fr_svchip_least_privilege(inputs)
	if (locale === "pt") return pt_svchip_least_privilege(inputs)
	if (locale === "zh") return zh_svchip_least_privilege(inputs)
	if (locale === "tr") return tr_svchip_least_privilege(inputs)
	if (locale === "ru") return ru_svchip_least_privilege(inputs)
	if (locale === "pl") return pl_svchip_least_privilege(inputs)
	return en_svchip_least_privilege(inputs)
});